import { ENUM_CompanyType } from '@api-new/common';
import { PlatformTypeEnum } from '@shared/enums/platform-type.enum';

export const companyTypeToPlatformType = (companyType: ENUM_CompanyType): PlatformTypeEnum => {
  switch (companyType) {
    case ENUM_CompanyType.COMPANY_TYPE_BROKER_COMPANY:
    case ENUM_CompanyType.COMPANY_TYPE_AGGREGATOR_COMPANY:
      return PlatformTypeEnum.Adviser;

    case ENUM_CompanyType.COMPANY_TYPE_LENDER_COMPANY:
      return PlatformTypeEnum.Lender;

    default:
      return PlatformTypeEnum.Adviser;
  }
};
